var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex gap-1 nested-menu-tab-button-container"},[_c('nested-menu-tab-button',{attrs:{"title":_vm.$t('sent_history'),"icon":"icon-list","route":"messageManagement.sentHistory"}}),_c('nested-menu-tab-button',{attrs:{"title":_vm.$t('received_history'),"icon":"icon-list","route":"messageManagement.receivedHistory"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }